// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","redirect":"/home","id":"1"},"2":{"name":"首页","path":"/home","id":"2"},"3":{"name":"Agreement","path":"/agreement-detail","id":"3"}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__Home__index" */'@/pages/Home/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__AgreementDetail__index" */'@/pages/AgreementDetail/index.tsx')),
},
  };
}
